import React, { Component } from "react";
import Panel from "../../../UI/Panel";
import { connect } from "react-redux";
import PageSubTitle from "../../../UI/PageSubTitle";
import { Link } from "react-router-dom";
import PanelBody from "../../../UI/Panel/PanelBody";
import user from "../../../../_assets/images/gallery/img_9.jpg";
import showMemberGallery from "../../../../_selectors/profileSelectors/showMemberGallery";
import getMemberTopImages from "../../../../_selectors/profileSelectors/getMemberTopImages";
import { map } from "lodash";
import Wrapper from "../../../../_hoc/Wrapper";

class ProfileImages extends Component {
  renderImages = () => {
    const { images } = this.props;

    if (images.length < 3) {
      return (
        <div class="row margin-bottom-10">
          {map(images, image => (
            <div class="col-md-4">
              <img src={image.thumbnail} class="img-responsive" />
            </div>
          ))}
        </div>
      );
    } else {
      let firstRow = (
        <div class="row margin-bottom-10">
          {map(images, (image, index) => {
            if (index < 3) {
              return (
                <div class="col-md-4">
                  <img src={image.thumbnail} class="img-responsive" />
                </div>
              );
            }
          })}
        </div>
      );

      let secondRow = (
        <div class="row margin-bottom-20">
          {map(images, (image, index) => {
            if (index >= 3) {
              return (
                <div class="col-md-4">
                  <img src={image.thumbnail} class="img-responsive" />
                </div>
              );
            }
          })}
        </div>
      );

      return (
        <Wrapper>
          {firstRow}
          {secondRow}
        </Wrapper>
      );
    }
  };
  render() {
    const { showImages, images, profileId } = this.props;
    if (!showImages) {
      return null;
    }
    if (images.length === 0) {
      return null;
    }
    return (
      <Panel>
        <PanelBody>
          <PageSubTitle>
            <h3>Gallery</h3>
          </PageSubTitle>
          {this.renderImages()}
          <Link
            to={`/view-profile/${profileId}/images`}
            className="btn btn-primary btn-sm pull-right"
          >
            View All
          </Link>
        </PanelBody>
      </Panel>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  showImages: showMemberGallery(state),
  images: getMemberTopImages(state)
});

export default connect(mapStateToProps)(ProfileImages);



// WEBPACK FOOTER //
// ./src/_components/ViewProfile/Profile/ProfileImages/index.js